import React from "react";
import { BrushCleaning } from "lucide-react";
import { RequestStatus } from "@/types/request";
import { IndicatorCell } from "@/components/pages/settlement/components/table-cells/IndicatorCell";

interface ServiceCellProps {
  status?: RequestStatus | string | null;
  className?: string;
}

export const RoomServiceCell: React.FC<ServiceCellProps> = ({
  status,
  className,
}) => {
  const normalizedStatus = status?.toUpperCase();
  const isCompleted =
    normalizedStatus === RequestStatus.DONE ||
    normalizedStatus === RequestStatus.COMPLETED;

  return (
    <IndicatorCell
      icon={<BrushCleaning className="text-indigo size-4" />}
      isDimmed={isCompleted}
      className={className}
    />
  );
};
